var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useState, useEffect } from "react";
import { t } from '@mp/locale';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { createSortedListByName, getCountries } from "../../services/countriesService";
export default function PropertyCountry(_a) {
    var cookie = _a.cookie, reset = _a.reset, loaded = _a.loaded, changeCountry = _a.changeCountry, props = __rest(_a, ["cookie", "reset", "loaded", "changeCountry"]);
    var _b = useState([]), countries = _b[0], setCountries = _b[1];
    var _c = useState('US'), selectedCountry = _c[0], setSelectedCountry = _c[1];
    useEffect(function () {
        getCountries().then(function (response) {
            var countryStrings = createSortedListByName(response);
            setCountries(countryStrings);
            loaded();
        });
    }, []);
    useEffect(function () {
        if (reset) {
            setSelectedCountry("");
        }
    }, [reset]);
    useEffect(function () {
        if (cookie) {
            setSelectedCountry(cookie);
        }
    }, [cookie]);
    return (_jsx("div", { children: !!countries.length && (_jsx(Autocomplete, { className: "mp-form-row-input", id: "country-select", options: countries.map(function (option) { return option.code; }), disableClearable: true, getOptionLabel: function (option) { var _a; return ((_a = countries.find(function (country) { return country.code === option; })) === null || _a === void 0 ? void 0 : _a.name) || ""; }, renderOption: function (props, option) {
                var _a;
                return (_createElement("li", __assign({}, props, { key: option }), (_a = countries.find(function (country) { return country.code === option; })) === null || _a === void 0 ? void 0 : _a.name));
            }, value: selectedCountry, onChange: function (e, newValue) {
                if (newValue) {
                    setSelectedCountry(newValue);
                    changeCountry(newValue);
                }
            }, renderInput: function (params) { return (_jsx(TextField, __assign({ "data-qa": "property-contry", className: "scheduler-inputs", variant: "standard" }, params, { label: t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.country.label"), inputProps: __assign({}, params.inputProps) }))); } })) }));
}
